import { MapPin, Phone, Clock, Navigation2, MessageCircle } from "lucide-react";
import { SITE, waHref } from "@/data/site";

export default function MapSection() {
  return (
    <section
      id="konum"
      data-testid="home-map-section"
      className="relative bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
        <div className="grid lg:grid-cols-5 gap-8 md:gap-10 items-stretch">
          <div className="lg:col-span-2 flex flex-col justify-center">
            <p className="chip-green mb-4">Konum</p>
            <h2 className="font-display text-3xl md:text-5xl text-[#0B1B33] leading-[1.05] mb-5 tracking-tight">
              Bize Bağlıca&apos;dan bir adım uzaktasınız.
            </h2>
            <p className="text-[#4B5A6E] leading-relaxed mb-8 max-w-md">
              Bağlıca Bulvarı üzerinde, ulaşımı kolay lokasyonumuzda sizi bekliyoruz. Uygulamada yol tarifi almak veya randevu için bize her zaman ulaşabilirsiniz.
            </p>

            <ul className="space-y-4 mb-8">
              <li className="flex items-start gap-3">
                <div className="h-10 w-10 rounded-xl bg-[#4F8B2A]/10 text-[#4F8B2A] flex items-center justify-center shrink-0">
                  <MapPin size={18} />
                </div>
                <div>
                  <p className="text-[10px] tracking-[0.22em] uppercase font-bold text-[#7C8CA0] mb-1">Adres</p>
                  <p className="text-[#0B1B33] font-medium leading-snug text-sm md:text-base">{SITE.address}</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="h-10 w-10 rounded-xl bg-[#4F8B2A]/10 text-[#4F8B2A] flex items-center justify-center shrink-0">
                  <Phone size={18} />
                </div>
                <div>
                  <p className="text-[10px] tracking-[0.22em] uppercase font-bold text-[#7C8CA0] mb-1">Telefon</p>
                  <a href={`tel:${SITE.phoneRaw}`} className="text-[#0B1B33] font-medium hover:text-[#4F8B2A] transition">{SITE.phone}</a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="h-10 w-10 rounded-xl bg-[#4F8B2A]/10 text-[#4F8B2A] flex items-center justify-center shrink-0">
                  <Clock size={18} />
                </div>
                <div>
                  <p className="text-[10px] tracking-[0.22em] uppercase font-bold text-[#7C8CA0] mb-1">Çalışma Saatleri</p>
                  <p className="text-[#0B1B33] font-medium text-sm md:text-base">{SITE.hours}</p>
                </div>
              </li>
            </ul>

            <div className="flex flex-wrap gap-3">
              <a
                href={SITE.mapUrl}
                target="_blank"
                rel="noreferrer"
                data-testid="map-directions"
                className="inline-flex items-center gap-2 h-11 px-5 rounded-full bg-gradient-to-br from-[#A8C520] to-[#3F7A2E] text-white text-[11px] tracking-[0.15em] uppercase font-bold hover:brightness-110 hover:shadow-[0_10px_24px_rgba(63,122,46,0.35)] transition-all"
              >
                <Navigation2 size={14} /> Yol Tarifi Al
              </a>
              <a
                href={waHref("Merhaba, konum ve randevu için bilgi alabilir miyim?")}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 h-11 px-5 rounded-full bg-[#10B981] text-white text-[11px] tracking-[0.15em] uppercase font-bold hover:brightness-110 transition"
              >
                <MessageCircle size={14} /> WhatsApp
              </a>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="relative h-[380px] md:h-[460px] rounded-3xl overflow-hidden shadow-xl border border-[#E5EAF0]">
              <iframe
                title="MediEste — Bağlıca Konumu"
                src="https://www.google.com/maps?q=Ba%C4%9Fl%C4%B1ca%20Bulvar%C4%B1%20Mert%20Caddesi%20No%3A4%2F2%20Etimesgut%20Ankara&output=embed"
                className="absolute inset-0 w-full h-full"
                loading="lazy"
                style={{ border: 0 }}
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
